import { getCheckoutOrderId } from "@client/content/modules/Checkout/lib";
import { getMultiselectValue, getVisibility } from "@client/lib/settings";
import {
  type ParametricSelector,
  TargetSelector,
  combinedStyleSelector,
  getLayoutColorSelector,
  getSettingValueSelector,
  pageSubTypeSelector
} from "@client/selectors";
import { type ElementVisibility, type WithSettings, type WithStyleSheet } from "@client/types";
import { createSelector } from "reselect";

const elementsFloatingMenuSelector = getSettingValueSelector(TargetSelector.Layout, "floatingMenu", "elements");
export const floatingMenuVisibilitySelector = createSelector(
  [elementsFloatingMenuSelector],
  (isVisible): ElementVisibility => getVisibility(isVisible)
);

export type FloatingMenuElement = "language" | "currency" | "cart";
export const makeElementsSelector = () => {
  const fmElementsSelector = getSettingValueSelector<FloatingMenuElement[]>(
    TargetSelector.Layout,
    "elements",
    "floatingMenu",
    getMultiselectValue
  );

  return createSelector([fmElementsSelector, pageSubTypeSelector], (elements, pageSubType) => {
    if (pageSubType === "Checkout" && getCheckoutOrderId()) {
      return elements.filter((x) => x !== "currency");
    }
    return elements;
  });
};

export const positionSelector = getSettingValueSelector(
  TargetSelector.Layout,
  "position",
  "floatingMenu"
) as ParametricSelector<WithSettings | WithStyleSheet, void, string>;

const separatorColorSelector = getLayoutColorSelector("separatorColor", "floatingMenu");

const advancedStyleSelector = combinedStyleSelector(
  TargetSelector.Layout,
  ["border", "boxShadow", "padding"],
  "floatingMenu"
);
export const styleSelector = createSelector(
  [advancedStyleSelector, separatorColorSelector],
  (advancedStyle, separatorColor): React.CSSProperties => ({
    ...advancedStyle,
    ["--sep-color" as string]: separatorColor
  })
);
